import { t } from 'ttag';
import classNames from 'classnames';

import { contacts, privacyPolicy, termsOfService } from '@urls';
import {
  shafaAndroidAppUrl,
  shafaIOSAppUrl,
  shafaFacebookPageUrl,
  shafaInstagramPageUrl,
  shafaYoutubePageUrl,
} from '@constants';
import { LayoutContainer } from '@ui/LayoutContainer';
import { Link } from '@ui/Link';
import { Image } from '@ui/Image';
import { LocalizedLink } from '@ui/LocalizedLink';
import { AppsPromotionQRCode, QRCodePlacement } from '@components/AppsPromotionQRCode';

import googlePlay from './images/google-play-2x-min.jpg';
import appStore from './images/app-store-2x-min.jpg';

import s from './Footer.sss';

const STORE_LINKS = [
  {
    href: shafaIOSAppUrl,
    img: appStore,
    name: 'App Store',
  },
  {
    href: shafaAndroidAppUrl,
    img: googlePlay,
    name: 'Google Play',
  },
];

const SOCIAL_LINKS = [
  {
    name: 'facebook',
    href: shafaFacebookPageUrl,
    className: s.socialLinkTypeFacebook,
  },
  {
    name: 'instagram',
    href: shafaInstagramPageUrl,
    className: s.socialLinkTypeInstagram,
  },
  {
    name: 'youtube',
    href: shafaYoutubePageUrl,
    className: s.socialLinkTypeYoutube,
  },
];

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    (
      <footer className={s.root}>
        <LayoutContainer className={s.layout}>
          <section className={s.row}>
            <div className={s.column}>
              <div className={s.appsInfo}>
                <AppsPromotionQRCode
                  className={s.qr}
                  placement={QRCodePlacement.Footer}
                  width="90"
                  height="90"
                />
                <div>
                  <p className={s.appsInfoTitle}>
                    {t`Завантажуйте додаток`}
                  </p>
                  <p className={s.appsInfoDescription}>
                    {t`Купуйте речі і спілкуйтесь у будь-якому місці`}
                  </p>
                </div>
              </div>

              <ul className={s.storeList}>
                {STORE_LINKS.map((link) => (
                  <li
                    key={link.href}
                    className={s.item}
                  >
                    <Link
                      className={s.storeLink}
                      theme="clean"
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        className={s.storeImage}
                        src={link.img}
                        width="152"
                        height="48"
                        alt={link.name}
                        lazy={true}
                      />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className={s.column}>
              <Link
                theme="black"
                target="_blank"
                href="https://shafa.kayako.com/category/1-kak-eto-rabotaet"
              >
                {t`Як це працює?`}
              </Link>

              <p className={s.contacts}>
                {t`Україна, 02121, місто Київ, Харківське шосе, будинок 201-203, літера 4Г`}
              </p>
            </div>

            <div className={s.column}>
              <ul className={s.linksList}>
                <li className={s.linksItem}>
                  <LocalizedLink
                    theme="black"
                    className={s.link}
                    href={privacyPolicy}
                  >
                    {t`Політика конфіденційності`}
                  </LocalizedLink>
                </li>
                <li className={s.linksItem}>
                  <LocalizedLink
                    theme="black"
                    className={s.link}
                    href={termsOfService}
                  >
                    {t`Договір-оферта`}
                  </LocalizedLink>
                </li>
                <li className={s.linksItem}>
                  <LocalizedLink
                    theme="black"
                    className={s.link}
                    href={contacts}
                  >
                    {t`Контакти`}
                  </LocalizedLink>
                </li>
              </ul>
            </div>

            <div className={s.column}>
              <p className={s.socialTitle}>
                {t`Ми у соц.мережах`}
              </p>
              <ul className={s.socialList}>
                {SOCIAL_LINKS.map((link) => (
                  <li
                    key={link.href}
                    className={s.socialItem}
                  >
                    <Link
                      className={classNames(s.socialLink, link.className)}
                      theme="clean"
                      href={link.href}
                      rel="noopener noreferrer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <section className={s.copyrightSection}>
            <p>
              {t`Речі за кліком серця. Всі права захищені`}
            </p>
            <p className={s.copyright}>
              {`© ${currentYear}`}
            &nbsp;
              <LocalizedLink
                theme="black"
                href="/"
              >
                Shafa.ua
              </LocalizedLink>
            </p>
          </section>
        </LayoutContainer>
      </footer>
    )
  );
};

export default Footer;
